// Select the target node that contains the displayed price
const targetNode = document.querySelector('[data-product-price]');

// Options for the observer (which mutations to observe)
const config = { childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
  for(const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Get the current displayed price
      const displayedPrice = parseFloat(targetNode.textContent.replace(/[^0-9.]/g, ''));

      // Check if the price is less than or equal to 770
      if (displayedPrice <= 770) {
        // Adjust the price by adding 5940
        const adjustedPrice = displayedPrice + 5940;

// Format adjusted price with comma separator in Japan
var formattedPrice = adjustedPrice.toLocaleString('ja-JP');

// Update the displayed price on the page
targetNode.innerHTML = '~¥' + formattedPrice;
        
      }
    }
  }
};

// Create a new observer instance
const observer = new MutationObserver(callback);

// Start observing the target node for mutations
observer.observe(targetNode, config);